import { useTranslation } from "react-i18next";
import { setLanguage } from "@/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Globe, Check } from "lucide-react";

const LANGS = [
  { code: "gl", label: "Galego", short: "GL" },
  { code: "es", label: "Castellano", short: "ES" },
];

export default function LanguageSelector({ compact = false }) {
  const { i18n } = useTranslation();
  const current = LANGS.find((l) => l.code === i18n.language) || LANGS[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          data-testid="language-selector"
          className="inline-flex items-center gap-1.5 rounded-full border hairline px-3 h-8 text-[12px] tracking-wide text-salnes-ink hover:bg-salnes-sand/60 transition-colors"
        >
          <Globe size={13} />
          <span className="font-medium">{current.short}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`lang-option-${l.code}`}
            onClick={() => setLanguage(l.code)}
            className="flex items-center justify-between cursor-pointer"
          >
            <span className="text-sm">{l.label}</span>
            {i18n.language === l.code && <Check size={14} className="text-salnes-emerald" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
